import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Link } from "react-router-dom";

const keyCodesAllowedForOTP = [
  "8",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "96",
  "97",
  "98",
  "99",
  "100",
  "101",
  "102",
  "103",
  "104",
  "105",
];

const VerifyOTP = ({ username, showOtpForm, setShowOtpForm }) => {
  const history = useHistory();
  const [otp1, setOtp1] = useState("");
  const [otp2, setOtp2] = useState("");
  const [otp3, setOtp3] = useState("");
  const [otp4, setOtp4] = useState("");
  const [otp5, setOtp5] = useState("");
  const [otp6, setOtp6] = useState("");
  const [otpTimer, SetOtpTimer] = useState(0);
  const [otpVerificationLoading, setOtpVerificationLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const handleModalClose = () => {
    setSuccessModal(false);
  };

  const otpFormFocus = (event) => {
    if (keyCodesAllowedForOTP.includes(event.which.toString())) {
      if (["Backspace", "Delete"].includes(event.key)) {
        const tabIndex = event.target.tabIndex;
        console.log("tabIndex", tabIndex);
        if (tabIndex > 0) {
          event.target.form.elements[tabIndex - 1].focus();
        }
      } else {
        const tabIndex = event.target.tabIndex;
        if (tabIndex < 5) {
          event.target.form.elements[tabIndex + 1].focus();
        }
      }
    }
  };

  const otpVerification = async (otp) => {
    setOtpVerificationLoading(true);
    const otpRequestBody = {
      username: username,
      confirmation_code: otp1 + otp2 + otp3 + otp4 + otp5 + otp6,
    };
    const otpVerificationCongig = {
      url: "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/email/verify",
      method: "post",
      data: JSON.stringify(otpRequestBody),
    };
    console.log("otpRequestBody\n", otpRequestBody);
    try {
      const otpVerificationResponse = await axios(otpVerificationCongig);
      if (otpVerificationResponse.data.isSuccess) {
        setOtpVerificationLoading(false);
        setSuccessModal(true);
      }
      console.log("otpVerificationResponse\n", otpVerificationResponse);
    } catch (e) {
      alert.error("Somathing went wrong. Please try again");
    }
    setOtpVerificationLoading(false);
  };

  const resendOtp = async () => {
    console.log("Resend OTP Working");
    const resendOTPData = { username: username };
    const resendOTPConfig = {
      method: "POST",
      url: "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/email/resend",
      data: resendOTPData,
    };
    try {
      const resendOtpResponse = await axios(resendOTPConfig);
      if (resendOtpResponse.data.isSuccess) {
        SetOtpTimer(30);
        setOtp1("");
        setOtp2("");
        setOtp3("");
        setOtp4("");
        setOtp5("");
        setOtp6("");
      } else {
        // OTP failure case to be written here
      }
      console.log("resendOtpResponse\n", resendOtpResponse);
    } catch (e) {
      alert.error("Somathing went wrong. Please try again");
    }
  };

  const SuccessfullSignUpModal = () => {
    return (
      <Dialog
        open={successModal}
        // onClose={handleModalClose}
        fullWidth
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Stack alignItems="center" gap={1}>
            <VerifiedIcon sx={{ color: "green", fontSize: "30px" }} />
            <Typography variant="body3">Succesfully Registered</Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              setShowOtpForm(false);
              history.push("/signup");
            }}
          >
            Sign Up again
          </button>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              history.push("/login");
            }}
          >
            Continue to login
          </button>
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    if (otpTimer > 0 && showOtpForm && !successModal) {
      const intervalID = setInterval(
        () => SetOtpTimer((timer) => timer - 1),
        1000
      );
      return () => {
        clearInterval(intervalID);
      };
    }
  });

  useEffect(() => {
    SetOtpTimer(30);
  }, [showOtpForm]);

  return (
    <Box
      flexGrow={1}
      gap={2}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="h2">OTP Verification</Typography>
      <Typography variant="body5">
        We have sent an OTP to your email. Please enter the OTP
      </Typography>

      <Form
        id="otp-form"
        className="d-flex align-items-center"
        onSubmit={(event) => {
          event.preventDefault();
          otpVerification();
        }}
      >
        <Form.Control
          style={{
            textAlign: "center",
            height: "35px",
            width: "35px",
            marginRight: "15px",
          }}
          tabIndex="0"
          maxLength={1}
          pattern="[0-9]*"
          inputMode="numeric"
          className="d-flex flex-column align-center justify-content-center"
          onKeyUp={(event) => {
            otpFormFocus(event);
          }}
          onChange={(event) => setOtp1(event.target.value)}
          value={otp1}
        />
        <Form.Control
          style={{
            textAlign: "center",
            height: "35px",
            width: "35px",
            marginRight: "15px",
          }}
          tabIndex="1"
          maxLength={1}
          pattern="[0-9]*"
          inputMode="numeric"
          className="d-flex flex-column align-center justify-content-center"
          onKeyUp={(event) => {
            otpFormFocus(event);
          }}
          onChange={(event) => setOtp2(event.target.value)}
          value={otp2}
        />
        <Form.Control
          style={{
            textAlign: "center",
            height: "35px",
            width: "35px",
            marginRight: "15px",
          }}
          tabIndex="2"
          maxLength={1}
          pattern="[0-9]*"
          inputMode="numeric"
          className="d-flex flex-column align-center justify-content-center"
          onKeyUp={(event) => {
            otpFormFocus(event);
          }}
          onChange={(event) => setOtp3(event.target.value)}
          value={otp3}
        />
        <Form.Control
          style={{
            textAlign: "center",
            height: "35px",
            width: "35px",
            marginRight: "15px",
          }}
          tabIndex="3"
          maxLength={1}
          pattern="[0-9]*"
          inputMode="numeric"
          className="d-flex flex-column align-center justify-content-center"
          onKeyUp={(event) => {
            otpFormFocus(event);
          }}
          onChange={(event) => setOtp4(event.target.value)}
          value={otp4}
        />
        <Form.Control
          style={{
            textAlign: "center",
            height: "35px",
            width: "35px",
            marginRight: "15px",
          }}
          tabIndex="4"
          maxLength={1}
          pattern="[0-9]*"
          inputMode="numeric"
          className="d-flex flex-column align-center justify-content-center"
          onKeyUp={(event) => {
            otpFormFocus(event);
          }}
          onChange={(event) => setOtp5(event.target.value)}
          value={otp5}
        />
        <Form.Control
          style={{
            textAlign: "center",
            height: "35px",
            width: "35px",
            marginRight: "15px",
          }}
          tabIndex="5"
          maxLength={1}
          pattern="[0-9]*"
          inputMode="numeric"
          className="d-flex flex-column align-center justify-content-center"
          onKeyUp={(event) => {
            otpFormFocus(event);
          }}
          onChange={(event) => setOtp6(event.target.value)}
          value={otp6}
        />
        <button
          type="submit"
          className="btn btn-primary"
          disabled={
            otpVerificationLoading ||
            [otp1, otp2, otp3, otp4, otp5, otp6].includes("")
          }
          style={{
            minWidth: "100px",
          }}
        >
          {otpVerificationLoading ? (
            <Spinner
              size="sm"
              animation="border"
              variant="light"
              style={{ height: "18px", width: "18px", marginTop: "2px" }}
            />
          ) : (
            "Verify OTP"
          )}
        </button>
      </Form>
      <Box>
        <button
          disabled={otpTimer !== 0}
          onClick={() => {
            resendOtp();
          }}
          className={
            otpTimer === 0 ? "text-primary mt-3" : "text-secondary mt-3"
          }
          style={{
            backgroundColor: "transparent",
            border: "none",
            paddingLeft: "0px",
          }}
        >
          Resend OTP
        </button>
        {otpTimer !== 0 ? (
          <span className="text-primary" style={{ fontWeight: "bold" }}>
            in {otpTimer} sec
          </span>
        ) : (
          ""
        )}
      </Box>
      <SuccessfullSignUpModal />
    </Box>
  );
};

export default VerifyOTP;
